import { IconType, SvgIcon } from './SvgIcon';

export const MicrophoneIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M8 1.3335C7.46957 1.3335 6.96086 1.54421 6.58579 1.91928C6.21071 2.29436 6 2.80306 6 3.3335V8.00016C6 8.5306 6.21071 9.0393 6.58579 9.41438C6.96086 9.78945 7.46957 10.0002 8 10.0002C8.53043 10.0002 9.03914 9.78945 9.41421 9.41438C9.78929 9.0393 10 8.5306 10 8.00016V3.3335C10 2.80306 9.78929 2.29436 9.41421 1.91928C9.03914 1.54421 8.53043 1.3335 8 1.3335Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6693 6.6665V7.99984C12.6693 9.23751 12.1776 10.4245 11.3024 11.2997C10.4273 12.1748 9.24028 12.6665 8.0026 12.6665C6.76493 12.6665 5.57794 12.1748 4.70277 11.2997C3.8276 10.4245 3.33594 9.23751 3.33594 7.99984V6.6665"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12.6665V14.6665"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

MicrophoneIcon.displayName = 'MicrophoneIcon';
